// extracted by mini-css-extract-plugin
module.exports = {"recipe":"recipe_recipe__3QjcR","image":"recipe_image__25loZ"};